export const DivisionFirstPlacePoints = {
    1: { goRound: 400, final: 675, aggregated: 675, percentage: 59 },
    2: { goRound: 300, final: 500, aggregated: 500, percentage: 60 },
    3: { goRound: 200, final: 350, aggregated: 350, percentage: 57 },
    4: { goRound: 100, final: 175, aggregated: 175, percentage: 57 },
    5: { goRound: 50, final: 80, aggregated: 80, percentage: 63 },
    y: { goRound: 50, final: 80, aggregated: 80, percentage: 63 },
};

export const DivisionsLastPlacePoints = {
    1: { goRound: 12.0, final: 20.3, aggregated: 0.3 },
    2: { goRound: 9.0, final: 15.0, aggregated: 15.0 },
    3: { goRound: 6.0, final: 10.5, aggregated: 10.5 },
    4: { goRound: 3.0, final: 5.3, aggregated: 5.3 },
    5: { goRound: 1.5, final: 2.4, aggregated: 2.4 },
    y: { goRound: 1.5, final: 2.4, aggregated: 2.4 },
};

export const topTenPlaceMultipliers = [ 1, 0.75, 0.8, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, ];

export const generatePointsTable = (division, goRounds, longRoundsPlaces, finalsPlaces?, aggregatePlaces?, pointsType) => {
    const pointsTable = [];
    const pointsTable11to40 = [];

    // Calculation for columns 1 to 10
    for (let col = 0; col < 10; col++) {
        const placePointsArray = topTenPlaceMultipliers.reduce(
            (pointsArray, multiplier, row) => {
                if (row <= col && row > 0 && row < 10) {
                    const points = pointsArray[row - 1] * multiplier;
                    pointsArray.push(points);
                }
                return pointsArray;
            }, [DivisionFirstPlacePoints[division][pointsType]],
        );
        pointsTable.push(placePointsArray);
    }

    // Calculations for columns 16 to 40
    for (let col = 40; col > 15; col--) {
        const pointsArray = [...pointsTable[9]];
        const divisionMinPoints = (DivisionFirstPlacePoints[division][pointsType] / 100) * 3;
        const subtractor = (pointsArray[9] - divisionMinPoints) / (col - 10);
        for (let row = 10; row < col; row++) {
            const points = pointsArray[row - 1] - subtractor;
            row <= col && pointsArray.push(points);
        }
        pointsTable11to40.push(pointsArray);
    }

    // Calculations for columns 11 to 15
    for (let col = 15; col > 10; col--) {
        const pointsArray = [...pointsTable[9]];
        const divisionMinPoints = Math.min(...pointsTable11to40[pointsTable11to40.length-1].slice(1, -1));
        const subtractor = (pointsArray[9] - divisionMinPoints) / (col - 10);
        for (let row = 10; row < col; row++) {
            const points = pointsArray[row - 1] - subtractor;
            row < col && pointsArray.push(points);
        }
        pointsTable11to40.push(pointsArray);
    }

    pointsTable.push(...pointsTable11to40.reverse());

    const pointsTableRounded = pointsTable.map((col) => {
      return col.map((point) => Math.round(point * 2) / 2);
    });

    return pointsTableRounded;
};